<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">
            Nostrud nostrud culpa minim aliquip deserunt dolor proident.
          </div>
        </div>
        <div>
          <img :src="require('../../assets/course.png')" alt="" />
        </div>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="flex justify-between">
        <page-header class="py-2 main-tenant-color"
          >Courses under this program</page-header
        >
        <div class="flex m-2">
          <!-- <lms-select
            v-model="form.industry"
            :items="filter"
            class="input1 my-2"
            placeholder="Filter by"
          />
          <lms-select
            v-model="form.industry"
            :items="sort"
            class="input1 m-2"
            placeholder="Sort By"
          /> -->
        </div>
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search"
          class="py-2"
          placeholder="Search by Program Name"
        />
      </div>
      <!-- <lms-table :search="search" class="mb-4" /> -->
      <div />
      <div class="flex flex-wrap">
        <div
          v-for="program in getTenantPrograms"
          :key="program.id"
          class="w-full md:w-1/3 lg:w-1/4"
        >
          <course-card class="m-4" />
        </div>
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    CourseCard: () => import("@/components/learner/course-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchTenantPrograms"]),
  },
  computed: {
    ...mapGetters(["getTenantPrograms"]),
  },
  mounted() {
    this.fetchTenantPrograms();
  },
};
</script>
<style scoped></style>
